<h1 class="widget-title">{{ title() }}</h1>

@if (canAdd()) {
  <xui-mat-autocomplete
    placeholder="Search Medication"
    [alwaysShowAddCard]="true"
    [searchObservable]="searchFn()"
    [addItemCardText]="addItemText()"
    [displayResultsCardTemplate]="displayResultsCardTemplate"
    [disabled]="isProcessing()"
    (addNewItem)="onAddNewItem()">
  </xui-mat-autocomplete>
}

<ng-template #displayResultsCardTemplate let-entry="result" let-queryText="queryText">
  @if (entry.sectionHeader) {
    <div class="search-section-header">{{ entry.sectionHeader }}</div>
  }
  @if (entry.kind === 'practice') {
    <div class="d-flex flex-row justify-content-between align-items-center">
      <span [innerHtml]="entry.medication.description + ' ' + (entry.medication.dosage || '') + ' ' + (entry.medication.diagnosisCode || '') | textHighlight: queryText"></span>
      <button mat-icon-button (click)="onItemSelected(entry.medication)" [disabled]="isProcessing()">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <mat-form-field color="primary" appearance="fill" class="compact w-100" subscriptSizing="dynamic">
      <mat-label>Comments/Notes</mat-label>
      <input matInput type="text" [value]="getResultData(entry.medication).comment" (input)="setResultComment(entry.medication.id, $any($event.target).value)"/>
    </mat-form-field>
  } @else {
    <div class="d-flex flex-row justify-content-between align-items-center">
      <xm-medicine-library-product-result [product]="entry.product" [queryText]="queryText"></xm-medicine-library-product-result>
      <button mat-icon-button aria-label="Add from the medicine library" (click)="onLibraryProductSelected(entry.product)" [disabled]="isProcessing()">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  }
</ng-template>

@if (isProcessing()) {
  <xui-loading-spinner></xui-loading-spinner>
}

<xm-medication-list-view
  [items]="items()"
  [readonly]="!canDelete()"
  [usePrimaryText]="usePrimaryText()"
  (itemRemoved)="onRemoveItem($event.item, $event.index)">
</xm-medication-list-view>

<div class="widget-footer">
  <ng-content select="[widget-footer]"></ng-content>
</div>
